export default __webpack_public_path__ + "static/media/assets-foiling_02.5d6b5033.jpg";